import { useTheme } from "@/App";

export const useThemeClasses = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return {
    theme,
    isDark,
    // Backgrounds
    bgPrimary: isDark ? 'bg-[#0A0A0A]' : 'bg-gray-50',
    bgCard: isDark ? 'bg-[#141414]' : 'bg-white',
    bgCardHover: isDark ? 'hover:bg-[#1A1A1A]' : 'hover:bg-gray-50',
    bgInput: isDark ? 'bg-[#0A0A0A]' : 'bg-white',
    bgTertiary: isDark ? 'bg-[#1A1A1A]' : 'bg-gray-50',
    
    // Borders
    borderColor: isDark ? 'border-white/5' : 'border-gray-200',
    borderHover: isDark ? 'hover:border-white/10' : 'hover:border-gray-300',
    borderInput: isDark ? 'border-white/10' : 'border-gray-200',
    
    // Text
    textPrimary: isDark ? 'text-white' : 'text-gray-900',
    textSecondary: isDark ? 'text-gray-300' : 'text-gray-700',
    textMuted: isDark ? 'text-gray-400' : 'text-gray-500',
    textPlaceholder: isDark ? 'placeholder:text-gray-500' : 'placeholder:text-gray-400',
    
    // Combined classes for common components
    card: isDark 
      ? 'bg-[#141414] border border-white/5' 
      : 'bg-white border border-gray-200 shadow-sm',
    cardHeader: isDark 
      ? 'border-b border-white/5' 
      : 'border-b border-gray-100',
    input: isDark 
      ? 'bg-[#0A0A0A] border-white/10 text-white placeholder:text-gray-500' 
      : 'bg-white border-gray-200 text-gray-900 placeholder:text-gray-400',
    listItem: isDark 
      ? 'bg-[#1A1A1A] border-white/5' 
      : 'bg-gray-50 border-gray-200',
    tableHeader: isDark 
      ? 'bg-white/5' 
      : 'bg-gray-50',
    tableRow: isDark 
      ? 'border-white/5 hover:bg-white/5' 
      : 'border-gray-100 hover:bg-gray-50',
    button: {
      outline: isDark 
        ? 'border-white/10 text-gray-300 hover:bg-white/5' 
        : 'border-gray-200 text-gray-700 hover:bg-gray-50',
      ghost: isDark 
        ? 'text-gray-400 hover:text-white hover:bg-white/5' 
        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100',
    },
  };
};

export default useThemeClasses;
